"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _g2plot = require("@antv/g2plot");
var _react = require("react");
var _base = _interopRequireDefault(require("../../components/base"));
var _jsxRuntime = require("react/jsx-runtime");
const DualAxesChart = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_base.default, {
    chart: _g2plot.DualAxes,
    ref: ref,
    ...props
  });
});
var _default = exports.default = DualAxesChart;